import React, { useEffect, useRef, useState } from "react"
// import { Link } from "gatsby"
import logo from "../images/Logo-Lets-Celebrate-fulltext.svg"
import { useTranslation } from "react-i18next"
import Button from "./Atoms/button"
import "../styles/navbar.css"

import {Link, useI18next} from 'gatsby-plugin-react-i18next';
import { Select } from "@mui/material";
import vi from "../images/vi_ensign.svg";
import eng from "../images/eng_ensign.svg";
import { graphql } from "gatsby";
import { DEFAULT_LANG } from "../constant/constant"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import { Collapse, ListItemButton, List, ListItemText, Box, Divider, ListItemIcon } from "@mui/material"
import MoreOptions from "./core/MoreOption"
import StoreIcon from '@mui/icons-material/Store';
import attireIcon from '../images/attire.svg';
import { getCurrentLanguageFromURL } from "../util"
import { checkGlobalDomain } from "../core/Domain"

const Navbar = () => {
	
	const { t } = useTranslation()
	const [openMenu, setOpenMenu] = useState(false)
	const [openCollapse, setOpenCollapse] = useState(false);
	
	const anchorRef = useRef(null);
	const [open, setOpen] = useState(false);
	
	const handleOpenMenu = () => {
		setOpen((prevOpen) => !prevOpen);
	};
	
	const handleCloseMenu = (event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}
		setOpen(false);
	};
	
	const handleLogin = () => {
		const loginPath = checkGlobalDomain() ? process.env.GATSBY_GLOBAL_LOGIN_PATH : process.env.GATSBY_LOGIN_PATH;
		window.open(loginPath)
	}
	
	const handleRegister = () => {
		const registerPath = checkGlobalDomain() ? process.env.GATSBY_GLOBAL_REGISTER_PATH : process.env.GATSBY_REGISTER_PATH;
		window.open(registerPath)
	}
	
	const {languages, originalPath, language} = useI18next();
	
	const [currentLanguage, setCurrentLanguage] = useState('vi');
	useEffect(() => {
		setCurrentLanguage(getCurrentLanguageFromURL());
	}, []);
	
	const handleDiscoverVendor = () => {
		window.open(process.env.GATSBY_VENDOR_SEARCH_PATH);
	}
	
	return <>
		<nav className="bg-white navbar-container fixed top-0 w-screen">
			<div className="max-w-7xl mx-auto px-8 py-5">
				<div className="flex items-center justify-between h-10">
					<div className="w-full justify-between flex items-center">
						<a href="/home">
							<img src={logo} className='w-80 h-16' alt='#logo' href="/home">
							</img>
						</a>
						
						<div className="hidden md:block">
							<div className="navbar-link ml-10 flex items-baseline space-x-2">
								
								<Box
									className='header-discover-container'
									ref={anchorRef}
									onClick={handleOpenMenu}
									// onMouseEnter={handleOpenMenu}
									style={{
										display: "flex",
										'&:hover': {
											cursor: 'pointer'
										},
										borderRadius: '10px'
									}}>
									<div
										className="text-black opacity-50 hover:opacity-100 px-3 py-2 rounded-md font-semibold"
										// to="/blog"
										// onClick={handleOpenMenu}
									>
										{t("Các tính năng")}
									</div>
									<KeyboardArrowDownIcon className='opacity-50 arrow-down'
									                       style={{ position: "relative", top: "10px", right: "7px" }}/>
									<MoreOptions
										className='more-options'
										placement='bottom-start'
										anchorRef={anchorRef}
										open={open}
										handleClose={handleCloseMenu}
										sx={{
											position: 'absolute',
											top: '-15px',
											right: '10px'
										}}
									>
										<List
											component="nav"
											sx={{
												width: '200px',
												p: 0
											}}
										>
											<ListItemButton
												sx={{height: '40px'}}
												// onClick={handleImportContent}
											>
												<Link
													to="/planning-tool"
												>
													{t("Lên kế hoạch cưới")}
												</Link>
											</ListItemButton>
											
											<ListItemButton
												sx={{height: '40px'}}
											>
												<Link
													to="/wedding-invitation"
												>
													{t("Thiệp cưới online")}
												</Link>
											</ListItemButton>
											
											{/*<ListItemButton*/}
											{/*	sx={{height: '40px'}}*/}
											{/*	// onClick={handleImportContent}*/}
											{/*>*/}
											{/*	{t("Các nhà cung cấp")}*/}
											{/*</ListItemButton>*/}
										</List>
									</MoreOptions>
									{/*<span className='hot-tag'> HOT </span>*/}
								</Box>
								{/*<Link*/}
								{/*	className="text-black opacity-50 hover:opacity-100 px-3 py-2 rounded-md font-semibold"*/}
								{/*	to="/about"*/}
								{/*>*/}
								{/*	{t("Về chúng tôi")}*/}
								{/*</Link>*/}
								<div>
									<Link
										className="text-black opacity-50 hover:opacity-100 px-3 py-2 rounded-md font-semibold"
										to="/testimonial"
									>
										{t("Phản hồi")}
									</Link>
									{/*<span className='hot-tag'> HOT </span>*/}
								</div>
								
								<Link
									className="text-black opacity-50 hover:opacity-100 px-3 py-2 rounded-md font-semibold"
									to="/pricing"
								>
									{t("Bảng giá")}
								</Link>
								<a
									className="text-black opacity-50 hover:opacity-100 px-3 py-2 rounded-md font-semibold"
									href="https://article.letscelebrate.vn/"
								>
									{t("Blog")}
								</a>
								{/*<div className=''>*/}
									{currentLanguage === 'vi' ?
										<Link to={originalPath} language='en' className='language-link text-black opacity-50 hover:opacity-100 px-3 py-2 rounded-md font-semibold'>
											<div className='flex'>
												<img className='' src={eng}></img> &nbsp;| &nbsp;EN
											</div>
										</Link>
										: <Link to={originalPath} language='vi' className='language-link flex text-black opacity-50 hover:opacity-100 px-3 py-2 rounded-md font-semibold'>
											<img className='' src={vi}></img> &nbsp;| &nbsp;VI
										</Link>}
								{/*</div>*/}
								
							</div>
							
							{/*<ul className="languages">*/}
							{/*	{languages.map((lng) => (*/}
							{/*		<li key={lng}>*/}
							{/*			<Link to={originalPath} language={lng}>*/}
							{/*				{lng}*/}
							{/*			</Link>*/}
							{/*		</li>*/}
							{/*	))}*/}
							{/*</ul>*/}
						</div>
						<div className="hidden md:block">
							<Button
								colorClass="bg-red"
								title={t("Đăng nhập")}
								textColor="text-white"
								marginClass="ml-5"
								onClick={handleLogin}
							></Button>
							<Button
								colorClass="bg-lightgrey"
								title={t("Đăng ký")}
								textColor="text-black"
								marginClass="ml-5"
								onClick={handleRegister}
							></Button>
						</div>
					</div>
					<div className="-mr-2 flex md:hidden">
						<button
							onClick={() => setOpenMenu(!openMenu)}
							className="text-gray-800 dark:text-white hover:text-gray-300 inline-flex items-center justify-center p-2 rounded-md focus:outline-none"
						>
							<svg
								width="20"
								height="20"
								fill="#D33C29"
								className="h-8 w-8"
								viewBox="0 0 1792 1792"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M1664 1344v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45z"></path>
							</svg>
						</button>
					</div>
				</div>
			</div>
			{openMenu && (
				<div className="mobile-navbar md:hidden">
					<div className="md-px-2 pt-2 pb-3 space-y-1 sm:px-3 navbar-link">
						{/*<a*/}
						{/*	className="text-gray-300 hover:text-gray-800 dark:hover:text-white block px-3 py-2 rounded-md text-base font-medium"*/}
						{/*	href="/home/about"*/}
						{/*>*/}
						{/*	{t("Về chúng tôi")}*/}
						{/*</a>*/}
						
						<Link
							className="text-gray-300 hover:text-gray-800 dark:text-white block px-3 py-2 rounded-md text-base font-medium"
							to="/wedding-invitation"
						>
							{t("Thiệp mời cưới")}
							{/*<span className='hot-tag-mobile'> HOT </span>*/}
						</Link>
						
						<Link
							className="text-gray-300 hover:text-gray-800 dark:text-white block px-3 py-2 rounded-md text-base font-medium"
							to="/planning-tool"
						>
							{t("Lên kế hoạch cưới")}
							{/*<span className='hot-tag-mobile'> HOT </span>*/}
						</Link>
						
						<Link
							className="text-gray-300 hover:text-gray-800 dark:text-white block px-3 py-2 rounded-md text-base font-medium"
							to="/testimonial"
						>
							{t("Phản hồi")}
						</Link>
						
						<Link
							className="text-gray-300 hover:text-gray-800 dark:hover:text-white block px-3 py-2 rounded-md text-base font-medium"
							to="/pricing"
						>
							{t("Bảng giá")}
						</Link>
						
						<a
							className="text-gray-300 hover:text-gray-800 dark:hover:text-white block px-3 py-2 rounded-md text-base font-medium"
							href="https://article.letscelebrate.vn/"
						>
							{t("Blog")}
						</a>
						
						{currentLanguage === 'vi' ?
							<Link to={originalPath} language='en' className='flex text-gray-300 hover:text-gray-800 dark:hover:text-white block px-3 py-2 rounded-md text-base font-medium'>
								<div className='flex'>
									<img className='' src={eng}></img> &nbsp;| &nbsp;EN
								</div>
							</Link>
							: <Link to={originalPath} language='vi' className='flex text-gray-300 hover:text-gray-800 dark:hover:text-white block px-3 py-2 rounded-md text-base font-medium'>
								<img className='' src={vi}></img> &nbsp;| &nbsp;VI
							</Link>}
							
						<Button
							colorClass="bg-red"
							title={t("Đăng nhập")}
							textColor="text-white"
							marginClass="ml-3"
							onClick={handleLogin}
						></Button>
						<Button
							colorClass="bg-lightgrey"
							title={t("Đăng ký")}
							textColor="text-black"
							marginClass="ml-5"
							onClick={handleRegister}
						></Button>
						
					</div>
				</div>
			)}
		</nav>
	</>
}

export default Navbar

export const query = graphql`
    query($language: String!) {
        locales: allLocale(filter: {language: {eq: $language}}) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
    }
`;